module.exports = require("skypager-util");


//////////////////
// WEBPACK FOOTER
// external "skypager-util"
// module id = 99
// module chunks = 0 1 2